<template>
  <div
    class="flex flex-col items-center justify-center py-20 bg-primary-50/30 dark:bg-primary-900/10 rounded-3xl border border-gray-200 dark:border-gray-700 backdrop-blur-sm transition-all hover:bg-primary-50/60 dark:hover:bg-primary-900/30"
  >
    <a-empty :description="description ?? t('common.empty')" class="opacity-80 drop-shadow-sm">
      <slot></slot>
    </a-empty>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '../composables/useI18n'

const { t } = useI18n()

defineProps<{
  description?: string
}>()
</script>
